// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {User} from '../../core/_models'
import {useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'
import useAuthorization from '../../../../../hooks/useAuthorization'
import {TooltipWrapper} from '../../../../../components/Tooltip'
import {impersonateUser} from '../../../../users/core/_resquest'

type Props = {
  row: Row<User>
}

const CustomRow: FC<Props> = ({row}) => {
  const id = String(row.original.id) as string
  const name = String(row.original.name)

  const navigate = useNavigate()
  const isAuthorized = useAuthorization('admin.users')
  const handleToEdit = () => navigate(`/admin/users/${id}/edit`)

  const handleImpersonate = async () => {
    const result = await Swal.fire({
      title: `Deseja logar como ${name}?`,
      text: 'Você navegará no sistema como este usuário até clicar em "Voltar ao admin".',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-secondary',
      },
    })
    if (!result.isConfirmed) return

    try {
      await impersonateUser(id)
      // Recarrega a aplicação para carregar o usuário impersonado e escolher a franquia
      window.location.href = '/auth/franquias'
    } catch (error: any) {
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error?.response?.data?.message ?? 'Não foi possível logar com este usuário.',
      })
    }
  }

  return (
    <tr {...row.getRowProps()}>
      {row.cells.map((cell) => {
        return (
          <td
            {...cell.getCellProps()}
            className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
          >
            {cell.render('Cell')}
          </td>
        )
      })}

      <td className='text-center min-w-120px'>
        {isAuthorized && (
          <TooltipWrapper tooltipText={'Editar'} tooltipPlacement={'top'}>
            <button
              className='btn btn-link btn-color-muted btn-active-color-danger'
              onClick={() => handleToEdit()}
            >
              <i className='ki-duotone ki-pencil me-5 fs-1'>
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
            </button>
          </TooltipWrapper>
        )}
        {isAuthorized && row.original.active && (
          <TooltipWrapper tooltipText={'Logar como'} tooltipPlacement={'top'}>
            <button
              className='btn btn-link btn-color-muted btn-active-color-danger'
              onClick={() => handleImpersonate()}
            >
              <i className='ki-duotone ki-entrance-left me-5 fs-1'>
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
            </button>
          </TooltipWrapper>
        )}
      </td>
    </tr>
  )
}
export {CustomRow}
